var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-defs",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "logo",
    viewBox: "0 0 344.2 64.7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "logo-icon",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4,15c5.5-3.2,9.8-5.7,14.6-5.7s9.2,2.5,14.6,5.7c7.6,4.4,16.8,9.7,31.4,10.6v-9.4 C75,15.4,67.3,10.9,60.4,6.9C54.3,3.4,48.5,0,41.1,0S27.9,3.4,21.8,6.9C15.9,10.3,9.3,14.1,0,15.7v9.4C11.8,23.5,19.8,18.9,26.4,15 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7,32.8c-14.2,2.7-27.6,5.2-43.7-1v9.8c7.4,2.4,14.2,3.3,20.8,3.3c8.6,0,16.7-1.5,24.6-3 c13.6-2.6,26.4-5,41.7,0.2v-9.7C70.8,27.6,57,30.2,43.7,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5,49.7c-15.4,0-30.3,1.8-43.5,5.3v9.7C13,60.9,27.9,59,43.5,59c15.6,0,30.6,2,43.6,5.7V55 C73.9,51.5,58.9,49.7,43.5,49.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "logo-text",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.8,25.7V38h-2.7V25.7H130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.7,35.7V38h-9.8v-2l4.3-4.2l-4.3-4.1v-2h9.6V28h-5.7l3.8,3.7l-4,4H143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.2,38h-2.6V25.7h2.7l3.7,7.1l3.7-7.1h2.6V38h-2.6v-7.7l-3.1,5.9h-1.4l-3.1-5.9V38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.9,25.7h2.7v4.7h5.3v-4.7h2.7V38h-2.7v-5.2h-5.3V38h-2.7V25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.6,38H177V25.7h2.8l5.6,8v-8h2.6V38h-2.6l-5.8-8.2V38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.5,25.7h2.7v4.7h5.3v-4.7h2.7V38h-2.7v-5.2h-5.3V38h-2.7V25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.9,25.7v2.4h-6V38h-2.7V25.7H219.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2,25.7h5.3c2.8,0,4.6,1.7,4.6,4.1c0,2.4-1.9,4.2-4.7,4.2h-2.5V38h-2.7V25.7z M227.3,31.9 c1.3,0,2.2-0.8,2.2-1.9s-0.9-2-2.2-2h-2.4v3.9H227.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.9,25.7h2.7v4.7h5.3v-4.7h2.7V38h-2.7v-5.2h-5.3V38h-2.7V25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,25.7v2.4h-6V38h-2.7V25.7H257.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9,25.6c3.7,0,6.4,2.7,6.4,6.2s-2.8,6.3-6.5,6.3c-3.7,0-6.4-2.7-6.4-6.2S261.2,25.6,264.9,25.6z  M264.8,35.7c2.2,0,3.8-1.7,3.8-3.8c0-2.2-1.6-3.8-3.8-3.8c-2.1,0-3.7,1.7-3.7,3.8C261.1,34,262.7,35.7,264.8,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.8,25.7h5.3c2.8,0,4.6,1.7,4.6,4.1c0,2.4-1.9,4.2-4.7,4.2h-2.5V38h-2.7V25.7z M278.8,31.9 c1.3,0,2.2-0.8,2.2-1.9s-0.9-2-2.2-2h-2.4v3.9H278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.3,25.7V38h-2.7V25.7H289.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.5,25.7h2.7l5,12.2h-3l-1-2.6h-4.9l-1,2.6h-2.8L296.5,25.7z M299.4,33.3l-1.7-4.5l-1.7,4.5H299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,25.7h2.7l5,12.2h-12.8L310,25.7z M313.9,35.6l-2.6-6.8l-2.7,6.8H313.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.2,25.6c3.7,0,6.4,2.7,6.4,6.2s-2.8,6.3-6.5,6.3c-3.7,0-6.4-2.7-6.4-6.2S321.6,25.6,325.2,25.6z  M325.2,35.7c2.2,0,3.8-1.7,3.8-3.8c0-2.2-1.6-3.8-3.8-3.8c-2.1,0-3.7,1.7-3.7,3.8C321.4,34,323,35.7,325.2,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.8,33.4l-4.7-7.7h3.1l3,5.2l3-5.2h3l-4.7,7.7V38h-2.7V33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,59h-1.3V48.5h-3.8v-1.1h9v1.1h-3.8V59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.7,47.2c3.4,0,6,2.6,6,5.9s-2.7,6-6,6s-6-2.6-6-5.9S140.3,47.2,143.7,47.2z M143.7,57.9 c2.7,0,4.7-2.1,4.7-4.8s-2.1-4.8-4.7-4.8s-4.7,2.1-4.7,4.8S141,57.9,143.7,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.3,47.3h9.5V59h-1.3V48.5h-6.9V59h-1.3V47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3,47.2c3.4,0,6,2.6,6,5.9s-2.7,6-6,6s-6-2.6-6-5.9S166.9,47.2,170.3,47.2z M170.3,57.9 c2.7,0,4.7-2.1,4.7-4.8s-2.1-4.8-4.7-4.8s-4.7,2.1-4.7,4.8S167.6,57.9,170.3,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,47.3v1.1h-6.4V59h-1.3V47.3H186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,47.3h4.7c2.4,0,4,1.6,4,3.7c0,2.1-1.7,3.7-4.1,3.7H190V59h-1.3V47.3z M193.2,53.6 c1.7,0,2.9-1.1,2.9-2.6c0-1.5-1.1-2.6-2.9-2.6H190v5.1H193.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.1,47.3h1.3l5,11.6H207l-1.4-3.4h-5.7l-1.4,3.4h-1.4L202.1,47.3z M205.2,54.6l-2.4-5.8l-2.5,5.8H205.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,58.7v1.1h-1.3v-1.1c-3.7,0-6.3-2.4-6.3-5.5s2.6-5.5,6.3-5.6v-1.1h1.3v1.1c3.7,0,6.3,2.4,6.3,5.5 S220.2,58.6,216.6,58.7z M215.3,57.5v-8.7c-2.9,0.1-5,1.9-5,4.4S212.4,57.5,215.3,57.5z M221.6,53.2c0-2.5-2-4.3-5-4.4v8.7 C219.5,57.5,221.6,55.6,221.6,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9,47.3V59h-1.3V47.3H226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.2,47.3h1.3v5.4l6-5.4h1.8l-6.4,5.6l6.7,6h-1.8l-6.4-5.8V59h-1.3V47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3,47.3h8.1v1.1h-6.8v3.9h5.9v1.1h-5.9v4.4h6.9V59h-8.2V47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4,57.9V59h-9v-0.9l4.6-5l-4.6-4.8v-0.9h8.8v1.1h-6.8l4.3,4.5l-4.5,4.9H260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3,59h-1.3V47.3h1.3l4.4,8.1l4.4-8.1h1.3V59h-1.3v-9.3l-4.1,7.4h-0.7l-4.1-7.4V59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,47.3h8.1v1.1h-6.8v3.9h5.9v1.1h-5.9v4.4h6.9V59h-8.2V47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.8,59l-4.2-10l-4.2,10h-1.4l4.9-11.6h1.3l4.9,11.6H300.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,47.3h8.1v1.1h-6.8v3.9h5.9v1.1h-5.9v4.4h6.9V59H304V47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.7,59h-1.3V48.5h-3.8v-1.1h9v1.1h-3.8V59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.6,47.3h8.1v1.1h-6.8v3.9h5.9v1.1h-5.9v4.4h6.9V59h-8.2V47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.7,57.9V59h-9v-0.9l4.6-5l-4.6-4.8v-0.9h8.8v1.1h-6.8L341,53l-4.5,4.9H343.7z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow",
    viewBox: "0 0 48.5 48.5"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 23.5,
    y: -9.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.9411 24)",
    width: 1,
    height: 67.9
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "48.5,48.5 0,48.5 0,47.5 47.5,47.5 47.5,0 48.5,0  "
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tag",
    viewBox: "0 0 35.8 36"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M35.8,36l-17.9-6.8L0,36V0h35.8V36z M1,1v33.6l16.9-6.4l16.9,6.4V1H1z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "circle",
    viewBox: "0 0 42.1 42.1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.1,42.1C9.5,42.1,0,32.7,0,21.1C0,9.5,9.5,0,21.1,0s21.1,9.5,21.1,21.1C42.1,32.7,32.7,42.1,21.1,42.1z M21.1,1 C10,1,1,10,1,21.1s9,20.1,20.1,20.1s20.1-9,20.1-20.1S32.1,1,21.1,1z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "square",
    viewBox: "0 0 38.3 38.3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.3,38.3H0V0h38.3V38.3z M1,37.3h36.3V1H1V37.3z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "email",
    viewBox: "0 0 41.5 30.5"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "transparent",
    points: "10.4,13.1 1,1.9 1,29.5 40.5,29.5 40.5,1.9 31.1,13.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "transparent",
    points: "30.7,12.1 40,1 1.6,1 10.9,12.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "40.5,1.9 40.5,29.5 1,29.5 1,1.9 0,0.7 0,30.5 41.5,30.5 41.5,0.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "40,1 30.7,12.1 10.9,12.1 1.6,1 1,1 1,1.9 10.4,13.1 31.1,13.1 40.5,1.9 40.5,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "1,1 1.6,1 40,1 40.5,1 40.5,1.9 41.5,0.7 41.5,0 0,0 0,0.7 1,1.9  "
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "down-arrow",
    viewBox: "0 0 58.2 29.8"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "29.1,29.8 0,0.7 0.7,0 29.1,28.4 57.5,0 58.2,0.7  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/ui.24a92892.svg";
export { ForwardRef as ReactComponent };